import notFound from "../assets/not-found.png";

const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <img src={notFound} alt="not found" />
      <h1>Page not found</h1>
    </div>
  );
};

export default NotFound;
